import './social-network-transfer-workspace.ajscss';

import { IAgentConfigDeprecatedService } from '@agent/core/agent/agent-config-deprecated.service';
import { IContactDeprecatedService } from '@agent/core/contact/contact-deprecated.service';
import { IExternalCenterTransfer } from '@agent/core/contact/transfer/models/external-transfer';
import { ITransfer, TransferTarget, TransferType } from '@agent/core/contact/transfer/models/transfer';
import { ITransferDeprecatedService } from '@agent/core/contact/transfer/transfer-deprecated.service';
import { IDirectoryService } from '@agent/core/search/directory.service';
import { SessionDeprecatedService } from '@commons/core/auth/session-deprecated.service';
import { HttpDeprecatedService } from '@commons/core/transport/http-deprecated.service';
import { ChannelDeprecatedImpl } from '@commons/models/channel';
import { IComponentController, IComponentOptions, ILogService, IPromise } from 'angular';
import { i18n } from 'i18next';

import { Configuration, Entity, None, Option, ProfileService, Skill } from '@contact/upgrade';

import templateUrl from './social-network-transfer-workspace.template.html';

type FilterType = 'group' | 'team' | 'skill';

interface IAgentFilter extends Entity {
  id: string;
  name: string;
  type: FilterType;
}

const MODULE_NAME = 'contactSocialNetworkTransferWorkspace';

export class SocialNetworkTransferWorkspaceCtrl implements IComponentController {
  responseId: string;
  availableSkills: any[] = [];
  externalCenterToTransfer: any[] = [];
  agentFilterType: string = 'teamOrGroup';
  availableFilters: IAgentFilter[] = [];
  availableSkillFilters: IAgentFilter[] = [];
  availableTargetTypes: TransferTarget[] = [];
  teamOrGroupFilter: IAgentFilter;
  skillsFilter: IAgentFilter[] = [];
  noResultsAgentTarget: boolean = false;
  resultsAgentTarget: IPromise<any>;
  public waitForWSResponse: boolean = true;
  public waitForWSDomainSkillResponse: boolean = true;
  private contactSkillNames: string[] = [];
  private _selectedSkills: Skill[] = [];

  constructor(
    protected readonly $log: ILogService,
    protected readonly $i18next: i18n,
    protected readonly profileService: ProfileService,
    protected readonly sessionDeprecatedService: SessionDeprecatedService,
    protected readonly httpDeprecated: HttpDeprecatedService,
    protected readonly configuration: Configuration,
    protected readonly agentConfigDeprecatedService: IAgentConfigDeprecatedService,
    protected readonly contactDeprecatedService: IContactDeprecatedService,
    protected readonly transferDeprecatedService: ITransferDeprecatedService,
    protected readonly directoryService: IDirectoryService
  ) {}

  get selectedSkills(): Skill[] {
    this.transfer.target = this._selectedSkills;
    return this._selectedSkills;
  }

  set selectedSkills(selectedSkills) {
    this.transfer.target = this._selectedSkills;
    this._selectedSkills = selectedSkills;
  }

  get transfer(): ITransfer {
    return this.transferDeprecatedService
      .getTransfer(this.responseId)
      .getOrElseFunc(() => this.transferDeprecatedService.createTransfer(this.responseId, ChannelDeprecatedImpl.INCOMING_SOCIAL_NETWORK));
  }

  get isDialingTarget(): boolean {
    return this.transferDeprecatedService.isDialingTarget(this.responseId);
  }

  $onInit(): void {
    // TODO check perm in admin
    if (this.profileService.hasPermission('CSR_SOCIAL_NETWORK_INCOMING::contact:transfer_to_skill')) {
      this.availableTargetTypes.push(TransferTarget.SKILL);
    }
    if (this.profileService.hasPermission('CSR_SOCIAL_NETWORK_INCOMING::contact:transfer')) {
      this.availableTargetTypes.push(TransferTarget.AGENT);
      this.noResultsAgentTarget = false;
    }

    this.transfer.type = TransferType.NOT_ACCOMPANIED;

    this.transferDeprecatedService.retriveTransferTec().subscribe(
      (next: IExternalCenterTransfer) => {
        this.externalCenterToTransfer = next.externalCenterToTransfer;
      },
      error => {
        this.$log.error(error);
      }
    );
    this.transferDeprecatedService
      .getAvailableSkills(this.responseId)
      .then(skills => {
        this.availableSkills = [...skills].sort((a, b) => {
          if (a.name.toLowerCase() > b.name.toLowerCase()) {
            return 1;
          }
          if (a.name.toLowerCase() < b.name.toLowerCase()) {
            return -1;
          }
          return 0;
        });
      })
      .finally(() => {
        this.waitForWSResponse = false;
      });

    this.agentConfigDeprecatedService.domainGroups.forEach(group => {
      this.availableFilters.push({
        id: group.id,
        name: group.name,
        type: 'group',
      });
    });
    this.agentConfigDeprecatedService.domainTeams.forEach(team => {
      this.availableFilters.push({
        id: team.id,
        name: team.name,
        type: 'team',
      });
    });

    if (this.availableFilters.length > 0) {
      this.teamOrGroupFilter = this.availableFilters[0];
      this.resultsAgentTarget = this.getAgents();
    }
    this.contactDeprecatedService.getContact(this.responseId).then(contact => {
      for (let skillName in contact.skills) {
        this.contactSkillNames.push(skillName);
      }
      // retrieve skill filtering for current contact channel
      this.agentConfigDeprecatedService
        .getDomainSkillsForChannel({
          type: contact.channel.type,
          direction: contact.channel.direction,
        })
        .subscribe(skills => {
          skills.forEach(skill =>
            this.availableSkillFilters.push({
              id: skill.id,
              name: skill.name,
              type: 'skill',
            })
          );
          this.waitForWSDomainSkillResponse = false;
        });
    });
    this.transfer.type = TransferType.NOT_ACCOMPANIED;
  }

  onTargetTeamOrGroupChange(): void {
    this.noResultsAgentTarget = false;
    this.resultsAgentTarget = this.getAgents();
  }

  onTargetChange(): void {
    this.noResultsAgentTarget = false;
    if (this.transfer.targetType === TransferTarget.SKILL) {
      this.transfer.type = TransferType.NOT_ACCOMPANIED;
    } else {
      this.transfer.type = TransferType.ACCOMPANIED;
    }
    this.transfer.target = '';
    this._selectedSkills = [];
    this.skillsFilter = [];
    if (this.agentFilterType === 'teamOrGroup') {
      this.getAgents();
    }
  }

  getTargetLabel(target: TransferTarget): string {
    let targetKey = TransferTarget[target].toLowerCase() + '_target';
    return this.$i18next.t('agent:contact.workspace.phone.transfer.' + targetKey);
  }

  getTeamOrGroupLabel(groupOrTeam: IAgentFilter): string {
    if (groupOrTeam.type === 'group') {
      return this.$i18next.t('agent:contact.workspace.phone.transfer.group');
    } else {
      return this.$i18next.t('agent:contact.workspace.phone.transfer.team');
    }
  }

  getAgents(text?: string): IPromise<any> {
    let groupFilter = None;
    let teamFilter = None;

    if (this.skillsFilter.length === 0) {
      let filter = Option.of(this.teamOrGroupFilter);
      groupFilter = filter.filter(f => f.type === 'group');
      teamFilter = filter.filter(f => f.type === 'team');
    }

    return this.directoryService
      .getInternalCorrespondents(
        this.sessionDeprecatedService.getProfile().domainId,
        groupFilter,
        teamFilter,
        this.skillsFilter,
        text,
        ChannelDeprecatedImpl.INCOMING_SOCIAL_NETWORK
      )
      .then(success => {
        if (success.data.length !== 0) {
          return success.data.map((agent: any) => ({
            id: agent.uuid,
            name: `${agent.firstName} ${agent.lastName}`,
            phoneNumber: agent.phoneNumber,
          }));
        } else {
          this.noResultsAgentTarget = true;
          return [];
        }
      });
  }
}

export class SocialNetworkTransferWorkspace implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    responseId: '<',
  } as { [binding: string]: string };
  controller = [
    '$log',
    '$i18next',
    'profileService',
    'sessionDeprecatedService',
    'httpDeprecated',
    'configuration',
    'agentConfigDeprecatedService',
    'contactDeprecatedService',
    'transferDeprecatedService',
    'directory',
    SocialNetworkTransferWorkspaceCtrl,
  ];
}

export default MODULE_NAME;
